var _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeSearchPlanner(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 36,
    viewBox: "0 0 34 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5105_31607",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 37
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.5273H33V33.2116C33 33.6862 32.8226 34.1413 32.5067 34.4769C32.1909 34.8125 31.7625 35.001 31.3158 35.001H2.68421C2.23753 35.001 1.80914 34.8125 1.49329 34.4769C1.17744 34.1413 1 33.6862 1 33.2116V13.5273Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.47307C1 4.99847 1.17744 4.54331 1.49329 4.20772C1.80914 3.87213 2.23753 3.68359 2.68421 3.68359H31.3158C31.7625 3.68359 32.1909 3.87213 32.5067 4.20772C32.8226 4.54331 33 4.99847 33 5.47307V13.5257H1V5.47307Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2637 24.263L15.3163 29.6314L25.4216 18.8945",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2637 1V8.1579M23.7374 1V8.1579",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5105_31607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.20898 -3.47266H37.2121V39.4747H-3.20898V-3.47266Z",
    fill: "#010101"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSearchPlanner);
export default __webpack_public_path__ + "static/media/HomeSearchPlanner.c7e464ef5ea525ad868c061461c55736.svg";
export { ForwardRef as ReactComponent };